import { getCollectionWithGenericFileSections } from '../services/collection';

export const LOADING_COLLECTION = 'LOADING_COLLECTION';
export const LOAD_COLLECTIONS = 'LOAD_COLLECTIONS';
export const LOAD_COLLECTION_WITH_GENERIC_SECTIONS = 'LOAD_COLLECTION_WITH_GENERIC_SECTIONS';
export const REMOVE_API_KEY = 'REMOVE_API_KEY';
export const SET_API_KEY = 'SET_API_KEY';
export const SET_SELECTED_COLLECTION_ID = 'SET_SELECTED_COLLECTION_ID';

export const loadingCollection = loading => ({
  type: LOADING_COLLECTION,
  loading
});

export const loadCollectionWithGenericFileSections = collection => dispatch => {
  dispatch(loadingCollection(true));
  getCollectionWithGenericFileSections(collection.id).then(collectionWithGenericFileSections =>
    dispatch({
      type: LOAD_COLLECTION_WITH_GENERIC_SECTIONS,
      collectionWithGenericFileSections
    })
  );
};

export const setSelectedCollectionId = collectionId => ({
  type: SET_SELECTED_COLLECTION_ID,
  collectionId: collectionId
});



// WEBPACK FOOTER //
// ./src/actions/collection.js